import { useEffect, useRef } from 'react';
import { bridge } from 'shared/src/utils';

export const useLogViewOverview = () => {
  const isLogged = useRef(false);

  useEffect(() => {
    if (isLogged.current) {
      return;
    }

    bridge.logAnalyticsEvent({
      name: 'VIEW_OVERVIEW',
      analytics: { SCREEN: 'OVERVIEW' },
    });
    isLogged.current = true;
  }, []);
};
